import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import SectionHeader from "@/components/site/SectionHeader";

const groups = [
  {
    category: "Allgemein",
    color: "bg-sage-100 text-sage-700",
    items: [
      {
        q: "Warum Gesundheit und Finanzen zusammen?",
        a: "Weil beide Bereiche unser Gefühl von Sicherheit, Ruhe und Freiheit prägen. Wenn dein Körper stabil ist und deine Finanzen klar strukturiert sind, entsteht Raum für das, was dir wirklich wichtig ist.",
      },
      {
        q: "Wie läuft ein Erstgespräch ab?",
        a: "In einem entspannten Gespräch (ca. 45 Minuten, telefonisch oder online) schauen wir gemeinsam, was dich beschäftigt und welcher Weg für dich sinnvoll ist. Unverbindlich und kostenfrei.",
      },
      {
        q: "Muss ich mich für einen Bereich entscheiden?",
        a: "Nein — du wählst, was für dich gerade passt. Viele starten mit einem Thema und erweitern später. Es gibt keinen Druck.",
      },
    ],
  },
  {
    category: "Gesundheitscoaching",
    color: "bg-sage-100 text-sage-700",
    items: [
      {
        q: "Was ist der Medical Medium Ansatz?",
        a: "Anthony Williams Ansatz sieht chronische Symptome ganzheitlich und verbindet gezielte Ernährung, Entlastung der Leber sowie spezifische Lebensmittel & Kräuter. Ich begleite dich sanft in der Umsetzung.",
      },
      {
        q: "Ersetzt das Coaching einen Arztbesuch?",
        a: "Nein. Das Coaching ist eine ergänzende Begleitung und ersetzt weder Diagnose noch medizinische Behandlung. Bei Beschwerden bitte immer auch medizinisch abklären lassen.",
      },
      {
        q: "Wie flexibel sind die Termine?",
        a: "Termine sind online oder telefonisch möglich — werktags und bei Bedarf am frühen Abend. Wir finden einen Rhythmus, der zu deinem Alltag passt.",
      },
    ],
  },
  {
    category: "Finanzberatung",
    color: "bg-clay-100 text-clay-600",
    items: [
      {
        q: "Warum ist die Beratung kostenfrei?",
        a: "Als Vermögensberaterin der DVAG werde ich von den Produktpartnern vergütet. Für dich entstehen keine direkten Kosten für die Beratung selbst.",
      },
      {
        q: "Was ist die DVAG?",
        a: "Die Deutsche Vermögensberatung ist einer der größten eigenständigen Finanzvertriebe Europas und bietet ganzheitliche Beratung zu Absicherung, Vorsorge und Vermögensaufbau.",
      },
      {
        q: "Bin ich nach der Beratung zu etwas verpflichtet?",
        a: "Nein. Die Beratung ist immer unverbindlich. Du entscheidest in Ruhe, ob und was du umsetzen möchtest.",
      },
    ],
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 bg-bone-100"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <SectionHeader
          chapter="06"
          label="Häufige Fragen"
          title="Antworten auf das,"
          italic="was dich bewegt."
        />

        <div className="mt-10 space-y-12">
          {groups.map((g) => (
            <div key={g.category}>
              <span className={`inline-flex items-center gap-2 px-3 h-7 rounded-full font-mono-fine text-[10px] tracking-[0.22em] uppercase mb-5 ${g.color}`}>
                <span className="w-1.5 h-1.5 rounded-full bg-current" />
                {g.category}
              </span>
              <Accordion
                type="single"
                collapsible
                className="w-full"
                data-testid={`faq-accordion-${g.category.toLowerCase()}`}
              >
                {g.items.map((item, i) => (
                  <AccordionItem
                    key={item.q}
                    value={`${g.category}-${i}`}
                    className="border-b border-bone-300"
                  >
                    <AccordionTrigger
                      data-testid={`faq-trigger-${g.category.toLowerCase()}-${i}`}
                      className="font-display font-light text-[1.35rem] md:text-[1.55rem] text-ink-900 hover:text-sage-700 transition-colors py-6 text-left"
                    >
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-ink-700 text-[16px] leading-relaxed pb-6 pr-8">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
